import React, { useEffect, useState } from "react";
import { StyleSheet, Dimensions } from "react-native";
import { View } from "../Themed";
import Colors from "../../constants/Colors";

type Props = {
  header: any;
  body?: any;
  footer: any;
  show: boolean;
};

const { width, height } = Dimensions.get("window");

export default function Popup(props: Props) {
  const { show, header, body, footer } = props;

  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    setModalVisible(show);
  }, [show]);

  return (
    <View style={styles.centeredViewContainer}>
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <View
            lightColor={Colors.base_colors_white}
            darkColor={Colors.nuetral_grey_600}
            style={styles.modalHeader}
          >
            {header}
          </View>
          <View
            lightColor={Colors.base_colors_white}
            darkColor={Colors.nuetral_grey_600}
            style={styles.modalBody}
          >
            {body}
          </View>
          <View
            lightColor={Colors.base_colors_white}
            darkColor={Colors.nuetral_grey_600}
            style={styles.modalFooter}
          >
            {footer}
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  centeredViewContainer: {
    flex: 1,
    position: "absolute",
    height: height,
    width: width,
    alignSelf: "center",
    elevation: 100,
    backgroundColor: "rgba(0,0,0,0.1)",
  },
  centeredView: {
    flex: 1,
    position: "absolute",
    height: height / 2,
    justifyContent: "flex-end",
    width: 300,
    alignSelf: "center",
    elevation: 100,
    //marginBottom: 200,
  },
  modalView: {
    backgroundColor: "white",
    borderRadius: 20,
    paddingHorizontal: 16,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalHeader: {
    alignItems: "center",
    paddingTop: 36,
  },
  modalBody: {
    paddingTop: 8,
  },
  modalFooter: {
    paddingTop: 24,
  },
});
